import React from 'react';

const useTableScrollY = ({ ref }) => {
  const [scrollY, setScrollY] = React.useState('100%');

  const handleWindowResize = React.useCallback(() => {
    if (ref.current) {
      setScrollY(`${ref.current.clientHeight - 80}px`);
    }
  }, [ref, setScrollY]);

  React.useLayoutEffect(() => {
    const observer = new ResizeObserver(handleWindowResize);
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [ref, handleWindowResize]);

  return scrollY;
};

export default useTableScrollY;
